import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Styles from '../../../../../assets/js/Styles';
import { ExternalMediaModel, isYouTubeMediaModel } from '../../../../../declarations/models/ExternalMediaModel';
import { getYouTubePlaybackUrl } from '../../../../../utils/url';
import Container from '../../../../../components/Container';
import { ChildrenProp } from '../../../../../declarations/ChildrenProp';

export interface YouTubeContentProps {
  item: ExternalMediaModel;
}

export const YouTubeContent: FC<YouTubeContentProps & ChildrenProp> = ({ item }) => {
  const { t: tComponents } = useTranslation('components');
  if (!isYouTubeMediaModel(item)) {
    console.error('YouTubeContent rendered with an incorrect model. This should never happen.');
    return null;
  }

  return (
    <Container p={2} top left fullWidth column>
      <Container
        fullWidth
        left
        top
        sx={{
          backgroundColor: Styles.Colors.LIGHTEST_BLUE,
          p: 2,
        }}>
        <Typography>
          {tComponents('MediaBlock.ExternalContentMessage')}

          <Typography sx={{ mt: 1 }}>
            <strong>Youtube ID:</strong> {item.local?.youtubeId} <br />
            <strong>Embed/iframe URL:</strong> {item.local.anySource}
          </Typography>
        </Typography>
      </Container>

      <Box
        component='iframe'
        width='560px'
        height='315px'
        src={getYouTubePlaybackUrl(item.local?.youtubeId) || ''}
        title='YouTube video player'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen
        sx={{
          border: 'none',
        }}
      />
    </Container>
  );
};

export default YouTubeContent;
